import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAttendanceHomeNew } from '../../Thunks/NewAttendanceThunks';
import { Attendance } from "../../Types/HeyTraderTypes/Attendances/New/Attendance";

interface NewAttendanceHomeSliceState {
  loader: boolean; // for refres pages and inital loadings
  attendanceHome: Attendance | null;
  errorDisplay: string | null;
}

// set inital valus
const initialState: NewAttendanceHomeSliceState = {
  loader: false,
  attendanceHome: null,
  errorDisplay: '',
}

// set state valu for api response
const newAttendanceHomeSlice = createSlice({
  name: 'newAttendanceHomeSlice',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      .addCase(getAttendanceHomeNew.rejected, (state, action) => {
        state.loader = false;
        state.errorDisplay = action.error.message!;
      })

      .addCase(getAttendanceHomeNew.pending, state => {
        state.loader = true;
        state.errorDisplay = null;
      })

      .addCase(getAttendanceHomeNew.fulfilled, (state, action: PayloadAction<Attendance>) => {
        state.loader = false;
        state.attendanceHome = action.payload;
      })
  }
})

export const { } = newAttendanceHomeSlice.actions
export default newAttendanceHomeSlice.reducer
